import { apiFetchShopper } from "./api";

export async function fetchAvatar() {
  return apiFetchShopper("/shopper/avatar");
}

export async function saveAvatar(avatar) {
  return apiFetchShopper("/shopper/avatar", {
    method: "POST",
    body: JSON.stringify({ avatar }),
  });
}